import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { HeadlineItem, type ProductItem } from '../types/search'

export type SearchHistory = ProductItem

type SearchState = {
  histories: SearchHistory[]
  isModalOpen: boolean
}

type SearchAction = {
  addNewHistory: (history: SearchHistory) => void
  clearHistory: () => void
  closeModal: () => void
  openModal: () => void
  setHistory: (histories: SearchHistory[]) => void
}

const initialState: SearchState = {
  histories: [],
  isModalOpen: false,
}

export const useSearchStore = create(
  persist<SearchAction & SearchState>(
    (set) => ({
      ...initialState,
      addNewHistory: (history: SearchHistory) =>
        set((state) => {
          // Remove the new item if it already exists in the history
          const filteredHistory = state.histories.filter(
            (item) => item.value !== history.value,
          )

          // Add the new item to the end of the history
          filteredHistory.push(history)

          // Ensure the headline is always the first item
          const finalHistory = [
            ...filteredHistory.filter((item) => item.type === 'product'),
          ]

          return {
            histories: finalHistory.slice(0, 6),
          }
        }),
      clearHistory: () => set({ histories: [] }),
      closeModal: () => set({ isModalOpen: false }),
      openModal: () => set({ isModalOpen: true }),
      setHistory: (histories: SearchHistory[]) => set({ histories: histories }),
    }),
    {
      name: 'searchLocalStorage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
